import { Grid } from "@mui/material";
import { useTranslation } from "@chr/online-shared-ui-localizations";

import { VisibilityBooking } from "@/common/apis/dtos";
import { InformationDisplay } from "@/common/components/information-display/InformationDisplay";

export interface QuickReferenceProps {
  booking: VisibilityBooking;
}

export const QuickReference = ({ booking }: QuickReferenceProps) => {
  const translate = useTranslation();

  const shipper = booking.services?.[0]?.serviceParties?.find(p => p.partyRole === 'Shipper')?.partyName;
  const consignee = booking.services?.[0]?.serviceParties?.find(p => p.partyRole === 'Consignee')?.partyName;
  const notifyParty = booking.notifyParty?.partyName;
  const incoTerms = booking.incoTerms;
  const customerFreightTerms = booking.customerInfo?.customerFreightTerms;
  const shipmentRole = booking.shipmentRole;

  const genericInfoDisplaySx = { '.MuiTypography-subtitle2': { paddingTop: '4px', paddingRight: '20px' } }

  return (
    <Grid container rowSpacing={2} paddingLeft={2} paddingRight={2} paddingBottom={2} className="quick-reference">
      {shipper &&
        <Grid item md={2} sm={4} xs={12}>
          <InformationDisplay
            truncateText={true}
            sx={genericInfoDisplaySx}
            label={translate('Shipper')}
            text={shipper}
          />
        </Grid>
      }

      {consignee &&
        <Grid item md={2} sm={4} xs={12}>
          <InformationDisplay
            truncateText={true}
            sx={genericInfoDisplaySx}
            label={translate('Consignee')}
            text={consignee}
          />
        </Grid>
      }

      {notifyParty &&
        <Grid item md={2} sm={4} xs={12}>
          <InformationDisplay
            truncateText={true}
            sx={genericInfoDisplaySx}
            label={translate('Notify Party')}
            text={notifyParty}
          />
        </Grid>
      }

      {incoTerms &&
        <Grid item md={2} sm={4} xs={12}>
          <InformationDisplay
            truncateText={true}
            sx={genericInfoDisplaySx}
            label={translate('INCO Terms')}
            text={incoTerms}
          />
        </Grid>
      }

      {customerFreightTerms &&
        <Grid item md={2} sm={4} xs={12}>
          <InformationDisplay
            sx={genericInfoDisplaySx}
            label={translate('Freight Terms')}
            text={customerFreightTerms}
          />
        </Grid>
      }

      {shipmentRole &&
        <Grid item md={2} sm={4} xs={12}>
          <InformationDisplay
            sx={genericInfoDisplaySx}
            label={translate('Shipment Role')}
            text={shipmentRole}
          />
        </Grid>
      }
    </Grid>
  )
}
